import type {
  DeleteDocumentExternalFilesDeleteRequestType,
  DeleteDocumentExternalFilesDeleteResponseType,
} from 'entities/document/api/types';
import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

export const deleteDocumentExternalFilesDelete = async (
  params: DeleteDocumentExternalFilesDeleteRequestType,
) => {
  const { attachmentId, documentId } = params;
  const url = `api/v2/documents/${documentId}/external-files/${attachmentId}`;
  await apiAuthClient.delete<DeleteDocumentExternalFilesDeleteResponseType>(
    url,
  );
};
